import { UPDATE } from 'react-admin';

export const EXERCISE_TOGGLE_APPROVE = 'EXERCISE_TOGGLE_APPROVE';
export const exerciseToggleApprove = (id, data) => ({
  type: EXERCISE_TOGGLE_APPROVE,
  payload: { id, data: { ...data, approved: !data.approved } },
  meta: { fetch: UPDATE, resource: 'exercises', refresh: true },
});

export const EXERCISE_TOGGLE_ENABLE_GLOBALWISE = 'EXERCISE_TOGGLE_ENABLE_GLOBALWISE';
export const exerciseToggleEnableGlobalwise = (id, data) => ({
  type: EXERCISE_TOGGLE_ENABLE_GLOBALWISE,
  payload: { id, data: { ...data, globalwise_approved: !data.globalwise_approved } },
  meta: { fetch: UPDATE, resource: 'exercises', refresh: true },
});



// WEBPACK FOOTER //
// ./src/resources/exercises/exerciseActions.js